/* eslint-disable */

export const getAuthHeader = (request) => {
	const config = {};
	if (process.env.NODE_ENV === 'development') {
		config.headers = {
			NoCookie: 0,
			companyName: request.companyName
		};
	} else {
		config.headers = {};
	}
	return config;
};
